import axiosInstance from '@services/axiosInstance';
// eslint-disable-next-line
import { values } from 'lodash';

const getService = {
  5: ({ id, values }) =>
    axiosInstance.patch(`/v1/authentications/${id}`, values),
  8: ({ id, entityCode, productCode }) => {
    const params = { entityCode, productCode };
    return axiosInstance.get(`/v1/customers/${id}/periods`, { params });
  },
  6: ({ region }) => axiosInstance.get(`/v1/communes/${region}`),
  10: ({ id, folio, date }) =>
    axiosInstance.get(`/v1/customers/${id}/documents/${folio}?date=${date}`),
  11: ({ id, page, entityCode, productCode }) => {
    const params = { page, entityCode, productCode };
    return axiosInstance.get(`/v1/customers/${id}/payments`, { params });
  },
  16: ({ id, entityCode, productCode }) => {
    const params = { entityCode, productCode };
    return axiosInstance.get(`/v1/customers/${id}`, { params });
  },
  18: ({ id, calendarPeriod, entityCode, productCode }) => {
    const params = { entityCode, productCode };
    return axiosInstance.get(
      `/v1/customers/${id}/movements/${calendarPeriod}`,
      { params }
    );
  },
  19: ({ id, entityCode, productCode }) => {
    const params = { entityCode, productCode };
    return axiosInstance.get(`/v1/customers/${id}/noninvoicedmovements`, {
      params,
    });
  },
  22: () => axiosInstance.get('/v1/accounttypes'),
  23: () => axiosInstance.get('/v1/banks'),
  24: () => axiosInstance.get('/v1/paymentmethods'),
  38: ({ id, entityCode, productCode }) => {
    const params = { identificationNumber: id, entityCode, productCode };
    return axiosInstance.get('/v1/negativerecords', { params });
  },
  39: (values) => axiosInstance.post('/v1/negativerecords', values),
  48: (values) => axiosInstance.put('/v1/creditcards/status', values),
  52: (values) => axiosInstance.post('/v1/validations', values),
  53: ({ id, values }) =>
    axiosInstance.put(`/v1/customers/${id}/contactabilitydata`, values),
  54: ({ id, values }) =>
    axiosInstance.put(`/v1/customers/${id}/commercialdata`, values),
  55: ({ id, values }) =>
    axiosInstance.put(`/v1/customers/${id}/personaldata`, values),
  56: ({ id }) =>
    axiosInstance.get(`/v1/insurances?identificationNumber=${id}`),
  57: ({ id, values }) =>
    axiosInstance.put(`/v1/customers/${id}/insurancedata`, values),
  58: ({ id, page }) =>
    axiosInstance.get(`/v1/documents?identificationNumber=${id}&page=${page}`),
  59: ({ folio }) => axiosInstance.get(`/v1/documents/${folio}`),
  60: (values) => axiosInstance.post('/v1/documents/emailing', values),
  61: (values) => axiosInstance.post('/v1/withdrawals/beginning', values),
  62: (values) => axiosInstance.post('/v1/withdrawals/simulation', values),
  63: (values) => axiosInstance.post('/v1/withdrawals/confirmation', values),
  64: (values) => axiosInstance.post('/v1/withdrawals/feasibility', values),
  65: ({ id, processId }) =>
    axiosInstance.get(`/v1/withdrawals/${id}/processes/${processId}`),
  66: (values) =>
    axiosInstance.post('/v1/withdrawals/confirmation/retry', values),
  67: (values) => axiosInstance.patch('v1/authentications', values),
  68: ({ id }) => axiosInstance.get(`/v1/customers/${id}/products`),
  79: (values) => axiosInstance.post('/v1/renegotiations/beginning', values),
  80: (values) => axiosInstance.post('/v1/renegotiations/simulation', values),
  81: (values) => axiosInstance.post('/v1/renegotiations/payment', values),
  82: (values) => axiosInstance.post('/v1/renegotiations/confirmation', values),
  83: ({ processId, id, amount, quotas }) =>
    axiosInstance.post('/v1/withdrawals/validationotp', {
      processId,
      identificationNumber: id,
      amount,
      quotas,
    }),
  84: ({ otpCode, processId, id }) =>
    axiosInstance.post('/v1/withdrawals/validationotp/attempt', {
      otpCode,
      processId,
      identificationNumber: id,
    }),
  92: ({ id, code1, code2, code3 }) => {
    const params = {
      code1,
      code2,
      code3,
    };
    return axiosInstance.get(`/v1/customers/${id}/accountstatements`, {
      params,
    });
  },
  93: ({ identificationNumber }) =>
    axiosInstance.get(`/v1/customers/${identificationNumber}/totps`),
  96: (values) => axiosInstance.post('/v1/prepaid/transfer/start', values),
  97: (values) => axiosInstance.post('/v1/prepaid/transfer/continue', values),
  98: () => axiosInstance.get('/v1/prepaid/utils/banks'),
  99: () => axiosInstance.post('/v1/prepaid/recipients'),
  100: (values) => axiosInstance.post('/v1/prepaid/recipient', values),
  101: (values) =>
    axiosInstance.delete('/v1/prepaid/recipient', {
      data: values,
      headers: { 'Content-Type': 'application/json' },
    }),
  102: (values) => axiosInstance.post('/v1/prepaid/recipient/add', values),
  103: (values) => axiosInstance.post('/v1/prepaid/recipient/account', values),
  // eslint-disable-next-line
  104: (values) =>
    axiosInstance.post('/v1/prepaid/recipient/account/tricot', values),
  // eslint-disable-next-line
  105: (values) => axiosInstance.put('/v1/prepaid/recipient/', values),
  // eslint-disable-next-line
  106: (values) =>
    axiosInstance.post('/v1/prepaid/recipient/account/add', values),
  107: (values) => axiosInstance.post('/v1/prepaid/recipients/nototp', values),
  108: (values) => axiosInstance.post('/v1/prepaid/recipient/nototp', values),
  109: (values) => axiosInstance.put('/v1/prepaid/recipient/account', values),
  110: (values) => axiosInstance.post('/v1/prepaid/transfer/finish', values),
  123: ({ entityCode, productCode }) => {
    const params = { entityCode, productCode };
    return axiosInstance.get('/v1/prepaid/transfer/amounts', { params });
  },
  124: (values) =>
    axiosInstance.delete('/v1/prepaid/recipient/account', {
      data: values,
      headers: { 'Content-Type': 'application/json' },
    }),
  112: ({ identificationNumber }) =>
    axiosInstance.get('/v1/restructure/validate', {
      params: { identificationNumber },
    }),
  113: (values) => axiosInstance.post('/v1/restructure/plan', values),
  114: (values) => axiosInstance.post('/v1/restructure/preConfirm', values),
  115: (values) => axiosInstance.post('/v1/restructure/status', values),
};

export default function tricorService(number, values = {}) {
  try {
    return getService[parseInt(number)](values);
  } catch (err) {
    return Promise.reject(err);
  }
}
